OCMS.QAS.StreetNumberActivated = OCMS.QAS.StreetNumberActivated || false;
OCMS.QAS.autoSelect = true;
/* global checaCPF*/
// let oldObj = '';
// let oldValor = '';
// const inteiro = new RegExp('[0-9]');

// function checaCPF(obj) {
//   let valor = obj.value;
//   const elem = obj;
//   if (valor !== oldValor || oldObj !== elem) {
//     for (let i = 0; i < valor.length; i += 1) {
//       if (!inteiro.test(valor.charAt(i))) {
//         valor = valor.substring(0, i) + valor.substring(i + 1, valor.length);
//         i = -1;
//       }
//     }
//     if (valor.length < 1) {
//       valor = '';
//     } else if (valor.length > 3 && valor.length < 7) {
//       valor = `${valor.substring(0, 3)}.${valor.substring(3, valor.length)}`;
//     } else if (valor.length > 6 && valor.length < 10) {
//       valor = `${valor.substring(0, 3)}.${valor.substring(3, 6)}
//       .${valor.substring(6, valor.length)}`;
//     } else if (valor.length > 9 && valor.length < 12) {
//       valor = `${valor.substring(0, 3)}.${valor.substring(3, 6)}
//       .${valor.substring(6, 9)}-${valor.substring(9, valor.length)}`;
//     } else if (valor.length > 11) {
//       valor = `${valor.substring(0, 3)}.${valor.substring(3, 6)}
//       .${valor.substring(6, 9)}-${valor.substring(9, 11)}`;
//     }
//     elem.value = valor;
//     oldValor = valor;
//     oldObj = elem;
//   }
// }
//
/* Telefone ###################################### */
// function Mascara(o, f) {
//   v_obj = o;
//   v_fun = f;
//   setTimeout('execmascara()', 1);
// }
//
// /* Função que Executa os objetos*/
// function execmascara() {
//   v_obj.value = v_fun(v_obj.value);
// }
//
// /* Função que Determina as expressões regulares dos objetos*/
// function leech(v) {
//   v = v.replace(/o/gi, '0');
//   v = v.replace(/i/gi, '1');
//   v = v.replace(/z/gi, '2');
//   v = v.replace(/e/gi, '3');
//   v = v.replace(/a/gi, '4');
//   v = v.replace(/s/gi, '5');
//   v = v.replace(/t/gi, '7');
//   return v;
// }
//
// /* Função que permite apenas numeros*/
// function Integer(v) {
//   return v.replace(/\D/g, '');
// }
//
// /* Função que padroniza telefone (11) 4184-1241*/
// function Telefone(v) {
//   v = v.replace(/\D/g, '');
//   v = v.replace(/^(\d\d)(\d)/g, '($1) $2');
//   v = v.replace(/(\d{4})(\d)/, '$1-$2');
//   return v;
// }
//
//
// /* Função que padroniza telefone (11) 41841241*/
// function TelefoneCall(v) {
//   v = v.replace(/\D/g, '');
//   v = v.replace(/^(\d\d)(\d)/g, '($1) $2');
//   return v;
// }

/* CEP */
// function MMformtCep(e, src, mask) {
//   if (window.event) { _TXT = e.keyCode; } else if (e.which) { _TXT = e.which; }
//   if (_TXT > 47 && _TXT < 58) {
//     const i = src.value.length;
//     const saida = mask.substring(0, 1);
//     const texto = mask.substring(i);
//     if (texto.substring(0, 1) !== saida) { src.value += texto.substring(0, 1); }
//     return true;
//   }
//
//   if (_TXT !== 8) { return false; }
//   return true;
// }


// ######################################//
// ## BEGIN: FUNÇÕES VALIDAÇÃO DE CPF  ##//
// ######################################//

require('jqmask');

function ClearStr(str, c) {
  let newStr = str;
  while (newStr.indexOf(c) !== -1) {
    newStr = newStr.replace(c, '');
  }
  return newStr;
}

function ParseNumb(c) {
  let nc = c;
  nc = ClearStr(nc, '-');
  nc = ClearStr(nc, '/');
  nc = ClearStr(nc, ',');
  nc = ClearStr(nc, '.');
  nc = ClearStr(nc, '(');
  nc = ClearStr(nc, ')');
  nc = ClearStr(nc, ' ');
  if ((parseFloat(nc) / nc !== 1)) {
    if (parseFloat(nc) * nc === 0) {
      return (nc);
    }

    return (0);
  }

  return nc;
}

function TestDigit(CNUMB, g) {
  let dig = 0;
  let ind = 2;
  for (let fouz = g; fouz > 0; fouz -= 1) {
    dig += parseInt(CNUMB.charAt(fouz - 1), 10) * ind;
    ind += 1;
  }
  dig %= 11;
  if (dig < 2) {
    dig = 0;
  } else {
    dig = 11 - dig;
  }
  if (dig !== parseInt(CNUMB.charAt(g), 10)) {
    return (false);
  }

  return (true);
}

function Verify(CNUMB) {
  const newCNUMB = ParseNumb(CNUMB);
  if ((newCNUMB === '00000000000') || (newCNUMB === '11111111111') || (newCNUMB === '22222222222') || (newCNUMB === '33333333333') ||
    (CNUMB === '44444444444') || (newCNUMB === '55555555555') || (newCNUMB === '66666666666') || (newCNUMB === '77777777777') ||
    (newCNUMB === '88888888888') || (newCNUMB === '99999999999') || (newCNUMB === '01234567890') || (newCNUMB === '12345678909')) {
    return false;
  }
  if (newCNUMB === 0) {
    return (false);
  }

  let g = newCNUMB.length - 2;
  if (TestDigit(newCNUMB, g)) {
    g = newCNUMB.length - 1;
    if (TestDigit(newCNUMB, g)) {
      return (true);
    }

    return (false);
  }

  return (false);
}

function isCPF(CNUMB) {
  if (Verify(CNUMB)) {
    return true;
  }

  return false;
}


const trim = str => str.toString().replace(/\$|\s/g, '');


//-----------------------------------------------------------------------------
// -- Valida se o valor informado é vazio
//-----------------------------------------------------------------------------
function isEmpty(value) {
  const str = trim(value);
  if (str !== '') {
    return false;
  }
  return true;
}

function validaCPFonblur(obj) {
  if (isEmpty(obj)) {
    return false;
  }

  return isCPF(obj);
}


function checkStateShippingMethod(element) {
  const state = $(element).find('option:selected').val();
  let retValue = false;

  const regExAllowedStates = new RegExp('^((AC)|(AM)|(AL)|(AP)|(BA)|(CE)|(DF)|(ES)|(GO)|(MA)|(MG)|(MT)|(MS)|(PA)|(PB)|(PE)|(PI)|(PR)|(RJ)|(RN)|(RO)|(RR)|(RS)|(SC)|(SE)|(SP)|(TO))$', 'i');
  if (regExAllowedStates.test(state)) {
    retValue = true;
  }

  return retValue;
}

function BrazilIsStateZipCodeValid(zip, state) {
  const statesByZipPrefix = [
        ['SP'],
        ['SP'],
        ['ES', 'RJ'],
        ['MG'],
        ['BA', 'SE'],
        ['AL', 'PB', 'PE', 'RN'],
        ['AC', 'AM', 'AP', 'CE', 'MA', 'PA', 'PI', 'RR'],
        ['DF', 'GO', 'MT', 'MS', 'RO', 'TO', 'MS'],
        ['PR', 'SC'],
        ['RS']
  ];

  const states = statesByZipPrefix[zip];
  if (states === undefined || states === null || states.length === 0) {
    return false;
  }
  return states.indexOf(state) >= 0;
}

$.validator.addMethod(
    'brazilOtherShippingTempState',
    (value, element) => checkStateShippingMethod(element)
);

$.validator.addMethod(
    'brazilAddressEndNumber',
    value => $.trim(value.toLowerCase()).match(/[0-9]$/)
);

$.validator.addMethod(
    'brazilCPF',
    value => validaCPFonblur($.trim(value.toLowerCase()))
);

$.validator.addMethod(
    'phoneValidation',
    (value) => {
      const newValue = $.trim(value.toLowerCase());
      if (newValue === '') {
        return true;
      }
      // return newValue.match(/^\(\d{2}\)\s{1}\d{4,5}-\d{4,5}$/);
      return value.match(/^(\(\d{2}\)\s{1}\d{4,5}-\d{4,5})|(\d{6,7}-\d{4,5})$/);
    }
);

$.validator.addMethod(
    'zipValidation',
    (value, element) => {
      const $el = $(element);
      const state = $(`[data-id='${$el.attr('data-form')}']`).find("[data-id='state']").val();
      if (value !== '') { return BrazilIsStateZipCodeValid(value.substring(0, 1), state); }

      return false;
    }
);

$(() => {
  $("[data-id='zip']").mask('99999-999', { placeholder: '' });

  if ($("[data-id='tel']").val() === '') {
    $("[data-id='tel']").mask('(99) 9999-9999?9', { placeholder: '' });
  }

  if ($("[data-id='mobile']").val() === '') {
    $("[data-id='mobile']").mask('(99) 9999-9999?9', { placeholder: '' });
  }

  $("[data-id='tel']").on('focus', () => {
    $("[data-id='tel']").mask('(99) 9999-9999?9', { placeholder: '' });
  });

  $("[data-id='mobile']").on('focus', () => {
    $("[data-id='mobile']").mask('(99) 9999-9999?9', { placeholder: '' });
  });

  $("[data-id='optional1']").mask('999.999.999-99', { placeholder: '' });
  $("[data-id='optional3']").mask('(99) 99999999?9', { placeholder: '' });
});


$(document).on('initialized.ocms.ultimate-form', (event, form) => {
  if (form !== undefined && form !== null &&
        OCMS !== undefined && OCMS !== null &&
        OCMS.QAS !== undefined && OCMS.QAS !== null &&
        OCMS.QAS.ZipFinders !== undefined && OCMS.QAS.ZipFinders !== null) {
    OCMS.QAS.ZipFinders.register({
      formId: form.id,
      resources: {
        finderLabel: 'CEP',
        finderButton: 'LOCALIZAR ENDEREÇO',
        resetButton: 'VOLTAR',
        resultLabel: 'Selecione o seu endereço',
        skipLabel: '',
        skipButton: ''
      },
      onInit(field) {
        $(field).mask('99999-999', { placeholder: ' ' });
      },
      onSelect(formSelect, values) {
        if (formSelect === undefined || formSelect === null) {
          return;
        }
        form.addressContainer.addClass('inline--first');
        form.streetNumberContainer.addClass('inline--second');
        let finalZip = values[4].address;
        if (OCMS.QAS.StreetNumberActivated) {
          const streetNumberRegex = /\d+/;
          const streetRangeRegex = /[\d]+[-][\d]+/;


          if (values.length > 5) {
            const nb = values[5].address;
            const numberMatches = nb.match(streetNumberRegex);
            const rangeMatches = nb.match(streetRangeRegex);

            if ((numberMatches !== null && numberMatches.length > 0) && rangeMatches == null) {
              form.streetNumber(nb);
            } else {
              form.streetNumber('');
            }
          }

          if (finalZip.match(streetRangeRegex) == null) {
            finalZip = window.searchedZip;
          }
        }

        formSelect.address(values[0].address);
        formSelect.address3(values[1].address);
        formSelect.city(values[2].address);
        formSelect.state(values[3].address);
        formSelect.zip(finalZip);
        formSelect.address2('');
        formSelect.address4('');
      }
    });
  }
});



// WEBPACK FOOTER //
// ./js/countryForm/brazil.form.js